module.exports = __webpack_public_path__ + "media/images/flags/32/Mayotte-bc40c62b9a5dc4bc97dc550127420693.png";